/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(1);
	var star_rating_controller_1 = __webpack_require__(2);
	var star_rating_component_1 = __webpack_require__(3);
	var styles = styles;
	var icons = icons;
	var star_rating_controller_2 = __webpack_require__(2);
	exports.StarRatingController = star_rating_controller_2.StarRatingController;
	var star_rating_component_2 = __webpack_require__(3);
	exports.StarRatingComponent = star_rating_component_2.StarRatingComponent;
	exports.angularStars = angular
	    .module('star-rating', [])
	    .controller('starRatingCtrl', star_rating_controller_1.StarRatingController)
	    .component('starRatingComp', new star_rating_component_1.StarRatingComponent())
	    .name;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = angular;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var StarRatingController = (function () {
	    function StarRatingController() {
	        //set default ctrl props
	        this.classEmpty = StarRatingController.DefaultClassEmpty;
	        this.classHalf = StarRatingController.DefaultClassHalf;
	        this.classFilled = StarRatingController.DefaultClassFilled;
	        this.pathEmpty = StarRatingController.DefaultSvgPathEmpty;
	        this.pathHalf = StarRatingController.DefaultSvgPathHalf;
	        this.pathFilled = StarRatingController.DefaultSvgPathFilled;
	        //set default Component Inputs
	        this._showHoverStars = StarRatingController.DefaultShowHoverStars;
	        this.labelHidden = StarRatingController.DefaultLabelHidden;
	        this._numOfStars = StarRatingController.DefaultNumOfStars;
	        this.stars = StarRatingController._getStarsArray(this.numOfStars);
	        this.setColor();
	        //set default Outputs
	    }
	    /**
	     * _getStarsArray
	     *
	     * returns an array of increasing numbers starting at 1
	     *
	     * @param numOfStars
	     * @returns {Array}
	     */
	    StarRatingController._getStarsArray = function (numOfStars) {
	        var stars = [];
	        for (var i = 0; i < numOfStars; i++) {
	            stars.push(i + 1);
	        }
	        return stars;
	    };
	    /**
	     * _getHalfStarVisible
	     *
	     * Returns true if there should be a half star visible, and false if not.
	     *
	     * @param rating
	     * @returns {boolean}
	     */
	    StarRatingController._getHalfStarVisible = function (rating) {
	        return Math.abs(rating % 1) > 0;
	    };
	    /**
	     * _getColor
	     *
	     * The default function for color calculation
	     * based on the current rating and the the number of stars possible.
	     * If a staticColor is set the function will use it as return value.
	     *
	     * @param rating
	     * @param numOfStars
	     * @param staticColor
	     * @returns {starRatingColors}
	     */
	    StarRatingController._getColor = function (rating, numOfStars, staticColor) {
	        rating = rating || 0;
	        //if a fix color is set use this one
	        if (staticColor) {
	            return staticColor;
	        }
	        //calculate size of smallest fraction
	        var fractionSize = numOfStars / 3;
	        //apply color by fraction
	        var color = 'default';
	        if (rating > 0) {
	            color = 'negative';
	        }
	        if (rating > fractionSize) {
	            color = 'ok';
	        }
	        if (rating > fractionSize * 2) {
	            color = 'positive';
	        }
	        return color;
	    };
	    Object.defineProperty(StarRatingController.prototype, "numOfStars", {
	        get: function () {
	            return this._numOfStars || StarRatingController.DefaultNumOfStars;
	        },
	        //getter and setter
	        set: function (value) {
	            this._numOfStars = (value > 0) ? value : StarRatingController.DefaultNumOfStars;
	            //update stars array
	            this.stars = StarRatingController._getStarsArray(this.numOfStars);
	            //update color
	            this.setColor();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StarRatingController.prototype, "rating", {
	        get: function () {
	            return this._rating;
	        },
	        set: function (value) {
	            if (value === undefined) {
	                return;
	            }
	            //validate and apply newRating
	            var newRating = 0;
	            if (value >= 0
	                && value <= this.numOfStars) {
	                newRating = value;
	            }
	            //limit max value to max number of stars
	            if (value > this.numOfStars) {
	                newRating = this.numOfStars;
	            }
	            this._rating = newRating;
	            //update ratingAsInteger. rating parsed to int for the value-[n] modifier
	            this.ratingAsInteger = parseInt(this._rating.toString());
	            //update halfStarsVisible
	            this.setHalfStarVisible();
	            //update calculated Color
	            this.setColor();
	            //fire onRatingChange event
	            var $event = { rating: this._rating };
	            if (typeof this.onRatingChange === 'function') {
	                this.onRatingChange({ $event: $event });
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StarRatingController.prototype, "showHalfStars", {
	        get: function () {
	            return this._showHalfStars;
	        },
	        set: function (value) {
	            this._showHalfStars = !!value;
	            //update halfStarVisible
	            this.setHalfStarVisible();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StarRatingController.prototype, "showHoverStars", {
	        get: function () {
	            return this._showHoverStars;
	        },
	        set: function (value) {
	            this._showHoverStars = !!value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StarRatingController.prototype, "disabled", {
	        get: function () {
	            return this._disabled;
	        },
	        set: function (value) {
	            this._disabled = !!value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StarRatingController.prototype, "readOnly", {
	        get: function () {
	            return this._readOnly;
	        },
	        set: function (value) {
	            this._readOnly = !!value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StarRatingController.prototype, "space", {
	        get: function () {
	            return this._space;
	        },
	        set: function (value) {
	            this._space = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StarRatingController.prototype, "starType", {
	        get: function () {
	            return this._starType;
	        },
	        set: function (value) {
	            this._starType = value || StarRatingController.DefaultStarType;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StarRatingController.prototype, "size", {
	        get: function () {
	            return this._size;
	        },
	        set: function (value) {
	            this._size = value || StarRatingController.DefaultSize;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StarRatingController.prototype, "speed", {
	        get: function () {
	            return this._speed;
	        },
	        set: function (value) {
	            this._speed = value || StarRatingController.DefaultSpeed;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StarRatingController.prototype, "labelPosition", {
	        get: function () {
	            return this._labelPosition;
	        },
	        set: function (value) {
	            this._labelPosition = value || StarRatingController.DefaultLabelPosition;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StarRatingController.prototype, "labelHidden", {
	        get: function () {
	            return this._labelHidden;
	        },
	        set: function (value) {
	            this._labelHidden = !!value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StarRatingController.prototype, "staticColor", {
	        get: function () {
	            return this._staticColor;
	        },
	        set: function (value) {
	            this._staticColor = value || undefined;
	            //update color.
	            this.setColor();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StarRatingController.prototype, "labelText", {
	        get: function () {
	            return this._labelText;
	        },
	        set: function (value) {
	            this._labelText = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StarRatingController.prototype, "id", {
	        get: function () {
	            return this._id;
	        },
	        set: function (value) {
	            this._id = value || (Math.random() * 10000).toString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StarRatingController.prototype.getComponentClassNames = function () {
	        var classNames = [];
	        classNames.push(this.rating ? 'value-' + this.ratingAsInteger : 'value-0');
	        classNames.push(this.showHoverStars ? 'hover' : '');
	        classNames.push(this.hoverRating ? 'hover-' + this.hoverRating : 'hover-0');
	        classNames.push(this.halfStarVisible ? 'half' : '');
	        classNames.push(this.space ? 'space-' + this.space : '');
	        classNames.push(this.labelHidden ? 'label-hidden' : 'label-visible');
	        classNames.push(this.labelPosition ? 'label-' + this.labelPosition : '');
	        classNames.push(this.color ? 'color-' + this.color : '');
	        classNames.push(this.starType ? 'star-' + this.starType : '');
	        classNames.push(this.speed);
	        classNames.push(this.size);
	        classNames.push(this.readOnly ? 'read-only' : '');
	        classNames.push(this.disabled ? 'disabled' : '');
	        return classNames.join(' ');
	    };
	    StarRatingController.prototype.svgVisible = function () {
	        return this.starType === "svg";
	    };
	    StarRatingController.prototype.setColor = function () {
	        //check if custom function is given
	        if (typeof this.getColor === "function") {
	            this.color = this.getColor(this.rating, this.numOfStars, this.staticColor);
	        }
	        else {
	            this.color = StarRatingController._getColor(this.rating, this.numOfStars, this.staticColor);
	        }
	    };
	    StarRatingController.prototype.setHalfStarVisible = function () {
	        //update halfStarVisible
	        if (this.showHalfStars) {
	            //check if custom function is given
	            if (typeof this.getHalfStarVisible === "function") {
	                this.halfStarVisible = this.getHalfStarVisible(this.rating);
	            }
	            else {
	                this.halfStarVisible = StarRatingController._getHalfStarVisible(this.rating);
	            }
	        }
	        else {
	            this.halfStarVisible = false;
	        }
	    };
	    /**
	     * $onChanges
	     *
	     * The components $onChange hook
	     *
	     * @param changes
	     */
	    StarRatingController.prototype.$onChanges = function (changes) {
	        var valueChanged = function (key, changes) {
	            if (key in changes) {
	                if (
	                //(changes[key].previousValue != 'UNINITIALIZED_VALUE' && changes[key].currentValue !== undefined)
	                changes[key].currentValue != changes[key].previousValue) {
	                    return true;
	                }
	            }
	            return false;
	        };
	        //---------------------------------------
	        //functions
	        //@Notice For some reason callback functions is not defined even there are defaults in the constructor
	        if (valueChanged('getColor', changes)) {
	            this.getColor = changes.getColor.currentValue;
	            this.setColor();
	        }
	        if (valueChanged('getHalfStarVisible', changes)) {
	            this.getHalfStarVisible = changes.getHalfStarVisible.currentValue;
	            this.setHalfStarVisible();
	        }
	        //boolean
	        if (valueChanged('showHalfStars', changes)) {
	            this.showHalfStars = changes.showHalfStars.currentValue;
	        }
	        if (valueChanged('space', changes)) {
	            this.space = changes.space.currentValue;
	        }
	        if (valueChanged('readOnly', changes)) {
	            this.readOnly = changes.readOnly.currentValue;
	        }
	        if (valueChanged('disabled', changes)) {
	            this.disabled = changes.disabled.currentValue;
	        }
	        if (valueChanged('labelHidden', changes)) {
	            this.labelHidden = changes.labelHidden.currentValue;
	        }
	        //number
	        if (valueChanged('rating', changes)) {
	            this.rating = changes.rating.currentValue;
	        }
	        if (valueChanged('numOfStars', changes)) {
	            this.numOfStars = changes.numOfStars.currentValue;
	        }
	        //string
	        if (valueChanged('labelText', changes)) {
	            this.labelText = changes.labelText.currentValue;
	        }
	        if (valueChanged('staticColor', changes)) {
	            this.staticColor = changes.staticColor.currentValue;
	        }
	        if (valueChanged('size', changes)) {
	            this.size = changes.size.currentValue;
	        }
	        if (valueChanged('speed', changes)) {
	            this.speed = changes.speed.currentValue;
	        }
	        if (valueChanged('labelPosition', changes)) {
	            this.labelPosition = changes.labelPosition.currentValue;
	        }
	        if (valueChanged('starType', changes)) {
	            this.starType = changes.starType.currentValue;
	        }
	    };
	    /**
	     * onStarClicked
	     *
	     * Is fired when a star is clicked. And updated the rating value.
	     * This function returns if the disabled or readOnly
	     * property is set. If provided it emits the onClick event
	     * handler with the actual rating value.
	     *
	     * @param rating
	     */
	    StarRatingController.prototype.onStarClicked = function (rating) {
	        if (!this.interactionPossible()) {
	            return;
	        }
	        this.rating = rating;
	        //fire onClick event
	        var $event = { rating: rating };
	        if (typeof this.onClick === 'function') {
	            this.onClick({ $event: $event });
	        }
	    };
	    StarRatingController.prototype.onStarHover = function (rating) {
	        if (!this.interactionPossible() || !this.showHoverStars) {
	            return;
	        }
	        this.hoverRating = rating ? parseInt(rating.toString()) : 0;
	        //fire onHover event
	        var $event = { hoverRating: this.hoverRating };
	        if (typeof this.onHover === 'function') {
	            this.onHover({ $event: $event });
	        }
	    };
	    StarRatingController.prototype.interactionPossible = function () {
	        return !this.readOnly && !this.disabled;
	    };
	    /**
	     * Get the closest matching element up the DOM tree.
	     * @private
	     * @param  {Element} elem     Starting element
	     * @param  {String}  selector Selector to match against
	     * @return {Boolean|Element}  Returns null if not match found
	     */
	    StarRatingController.prototype.getClosest = function (elem, selector) {
	        // Element.matches() polyfill
	        if (!Element.prototype.matches) {
	            Element.prototype.matches =
	                Element.prototype.matchesSelector ||
	                    Element.prototype.mozMatchesSelector ||
	                    Element.prototype.msMatchesSelector ||
	                    Element.prototype.oMatchesSelector ||
	                    Element.prototype.webkitMatchesSelector ||
	                    function (s) {
	                        var matches = (this.document || this.ownerDocument).querySelectorAll(s), i = matches.length;
	                        while (--i >= 0 && matches.item(i) !== this) {
	                        }
	                        return i > -1;
	                    };
	        }
	        // Get closest match
	        for (; elem && elem !== document; elem = elem.parentNode) {
	            if (elem.matches(selector))
	                return elem;
	        }
	        return null;
	    };
	    StarRatingController.DefaultClassEmpty = "default-star-empty-icon";
	    StarRatingController.DefaultClassHalf = "default-star-half-icon";
	    StarRatingController.DefaultClassFilled = "default-star-filled-icon";
	    StarRatingController.DefaultNumOfStars = 5;
	    StarRatingController.DefaultShowHoverStars = false;
	    StarRatingController.DefaultSize = "medium";
	    StarRatingController.DefaultSpeed = "noticeable";
	    StarRatingController.DefaultLabelPosition = "left";
	    StarRatingController.DefaultLabelHidden = false;
	    StarRatingController.DefaultStarType = "svg";
	    StarRatingController.DefaultAssetsPath = "img/";
	    StarRatingController.DefaultSvgPath = StarRatingController.DefaultAssetsPath + "star-rating.icons.svg";
	    StarRatingController.DefaultSvgEmptySymbolId = "star-empty";
	    StarRatingController.DefaultSvgHalfSymbolId = "star-half";
	    StarRatingController.DefaultSvgFilledSymbolId = "star-filled";
	    StarRatingController.DefaultSvgPathEmpty = StarRatingController.DefaultSvgPath + "#" + StarRatingController.DefaultSvgEmptySymbolId;
	    StarRatingController.DefaultSvgPathHalf = StarRatingController.DefaultSvgPath + "#" + StarRatingController.DefaultSvgHalfSymbolId;
	    StarRatingController.DefaultSvgPathFilled = StarRatingController.DefaultSvgPath + "#" + StarRatingController.DefaultSvgFilledSymbolId;
	    return StarRatingController;
	}());
	exports.StarRatingController = StarRatingController;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var star_rating_controller_1 = __webpack_require__(2);
	var starRatingTpl = __webpack_require__(4);
	var StarRatingComponent = (function () {
	    function StarRatingComponent() {
	        this.bindings = {
	            id: '<',
	            rating: '<',
	            showHalfStars: '<',
	            showHoverStars: '<',
	            numOfStars: '<',
	            size: '<',
	            space: '<',
	            staticColor: '<',
	            disabled: '<',
	            starType: '<',
	            labelText: '<',
	            labelHidden: '<',
	            labelPosition: '<',
	            speed: '<',
	            readOnly: '<',
	            getColor: '<',
	            getHalfStarVisible: '<',
	            onHover: '&',
	            onClick: '&',
	            onRatingChange: '&'
	        };
	        this.replace = true;
	        this.controller = star_rating_controller_1.StarRatingController;
	        this.templateUrl = starRatingTpl;
	    }
	    return StarRatingComponent;
	}());
	exports.StarRatingComponent = StarRatingComponent;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	var path = 'src/star-rating.tpl.html';
	var html = "<div id={{$ctrl.id}} class=rating ng-class=$ctrl.getComponentClassNames()> <div ng-show=$ctrl.labelText class=label-value>{{$ctrl.labelText}}</div> <div class=star-container ng-mouseleave=$ctrl.onStarHover()> <div class=star ng-repeat=\"star in $ctrl.stars track by $index\" ng-click=$ctrl.onStarClicked(star) ng-mouseover=$ctrl.onStarHover(star)> <i class=\"star-empty {{$ctrl.classEmpty}}\" ng-if=!$ctrl.svgVisible()></i> <i class=\"star-half {{$ctrl.classHalf}}\" ng-if=!$ctrl.svgVisible()></i> <i class=\"star-filled {{$ctrl.classFilled}}\" ng-if=!$ctrl.svgVisible()></i> <svg class=\"star-empty {{$ctrl.classEmpty}}\" ng-if=$ctrl.svgVisible()> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href={{$ctrl.pathEmpty}}></use> </svg> <svg class=\"star-half {{$ctrl.classHalf}}\" ng-if=$ctrl.svgVisible()> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href={{$ctrl.pathHalf}}></use> </svg> <svg class=\"star-filled {{$ctrl.classFilled}}\" ng-if=$ctrl.svgVisible()> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href={{$ctrl.pathFilled}}></use> </svg> </div> </div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js